import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "card reports-buyer"
}
const _hoisted_3 = {
  key: 0,
  class: "reports-container-estate"
}
const _hoisted_4 = { class: "chart-pie-container" }
const _hoisted_5 = { class: "reports-container-title" }
const _hoisted_6 = { class: "label-text-title" }
const _hoisted_7 = {
  key: 0,
  class: "chart-pie"
}
const _hoisted_8 = {
  key: 1,
  class: "chart-no-data report-no-data"
}
const _hoisted_9 = { class: "chart-pie-container" }
const _hoisted_10 = { class: "reports-container-title" }
const _hoisted_11 = { class: "label-text-title" }
const _hoisted_12 = { class: "chart-bar-container" }
const _hoisted_13 = {
  key: 0,
  class: "chart-bar"
}
const _hoisted_14 = {
  key: 1,
  class: "chart-no-data report-no-data"
}
const _hoisted_15 = {
  key: 1,
  class: "report-no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "chart-title-buyer-type" }, [
          _createElementVNode("h2", { class: "title-main" }, "Buyer Insights (Location)")
        ], -1)),
        ($setup.shouldRenderCharts)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.buyerTypeFromPostcodeAndState, (buyer, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "reports-container-charts",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h2", _hoisted_6, _toDisplayString(buyer.estate) + " (State)", 1)
                    ]),
                    (!$setup.areAllCountsZero(buyer.percentageState))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode($setup["ChartForReports"], {
                            labels: buyer.state,
                            setData: buyer.percentageState,
                            backgroundColor: $setup.backgroundColorForBuyerLocation,
                            chartType: $setup.ChartsTypes.DOUGHNUT,
                            options: $setup.optionsPieChartBuyerLocation
                          }, null, 8, ["labels", "setData", "backgroundColor", "chartType", "options"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("h2", { class: "subtitle-main" }, "No data to display", -1)
                        ]))]))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h2", _hoisted_11, _toDisplayString(buyer.estate) + " (Postcode)", 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "reports-container-top-five" }, [
                        _createElementVNode("h2", { class: "label-text-title" }, "Top 5 Postcodes:")
                      ], -1)),
                      (!$setup.areAllCountsZero(buyer.totalPostcode))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode($setup["ChartForReports"], {
                              labels: buyer.postcode,
                              setData: buyer.totalPostcode,
                              backgroundColor: $setup.backgroundColorForBuyerLocationBar,
                              chartType: $setup.ChartsTypes.BAR,
                              options: $setup.optionsForHorizontalBarchart
                            }, null, 8, ["labels", "setData", "backgroundColor", "chartType", "options"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("h2", { class: "subtitle-main" }, "No data to display", -1)
                          ]))]))
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("h2", { class: "subtitle-main" }, "No data to display", -1)
            ]))]))
      ]))
}